// Basic ellipsis style
export const baseEllipsisStyle = `
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// Block ellipsis style
export const ellipsisStyle = `
  ${baseEllipsisStyle}
  max-width: 100%;
`;